import { Box } from '@material-ui/core'
import { ExperianReportForm } from 'components/IntegrationReportForms/ExperianReportForm'
import { useAdditionalMaterialStyle } from 'containers/MaterialUiContainer/additionalStyles'
import React from 'react'

export const ExperianReportContainer = () => {
  const additionalStyle = useAdditionalMaterialStyle()
  return (
    <Box className={additionalStyle.wrapper} mb="2rem">
      <ExperianReportForm />
    </Box>
  )
}
